// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

import EntityItem from "metabase/common/components/EntityItem";

export const EntityItemMenu = styled(EntityItem.Menu)`
  color: var(--mb-color-text-secondary);
`;
